export const VERSION = "0.2.4";
//# sourceMappingURL=version.js.map